import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { useAppSelector } from "../../../store/reducers";
import { getAddressParts } from "../../../utils/format";
import { Step } from "../constants";

type IProps = Immutable<{
    onEdit?: (event?: React.MouseEvent<HTMLElement>) => void;
}>;

export const BillingAddressSummary = (props: IProps): React.ReactNode => {
    const form = useAppSelector((state) => state.checkout.form);
    const showSummary = useAppSelector(
        (state) => state.checkout.form.current_step > Step.BILLING_ADDRESS,
    );

    const summaryClasses = classNames({
        "checkout-step__summary": true,
        "checkout-step__summary--collapsed": !showSummary,
    });
    return (
        <div className={summaryClasses}>
            <h3 className="checkout-step__label">{t`Bill to:`}</h3>
            <div className="checkout-step__billing-address">
                {`${form.billing_first_name} ${form.billing_last_name}`}
                <br />
                {form.billing_line1}
                <br />
                {form.billing_line2 && (
                    <>
                        {form.billing_line2}
                        <br />
                    </>
                )}
                {
                    getAddressParts({
                        line1: form.billing_line1,
                        line2: form.billing_line2,
                        city: form.billing_line4,
                        state: form.billing_state,
                        postal: form.billing_postcode,
                    }).cityStatePostal
                }
                <br />
                {form.billing_phone_number}
            </div>
            {props.onEdit && (
                <a
                    className="checkout-step__back"
                    href="#"
                    onClick={props.onEdit}
                >
                    {t`Edit`}
                </a>
            )}
        </div>
    );
};
